/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formatter_Faq_Q4Inputs */

const en_formatter_faq_q4 = /** @type {(inputs: Formatter_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is there a size limit?`)
};

const ko_formatter_faq_q4 = /** @type {(inputs: Formatter_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`크기 제한이 있나요?`)
};

const ja_formatter_faq_q4 = /** @type {(inputs: Formatter_Faq_Q4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サイズ制限はありますか？`)
};

/**
* | output |
* | --- |
* | "Is there a size limit?" |
*
* @param {Formatter_Faq_Q4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const formatter_faq_q4 = /** @type {((inputs?: Formatter_Faq_Q4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formatter_Faq_Q4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_formatter_faq_q4(inputs)
	if (locale === "ko") return ko_formatter_faq_q4(inputs)
	return ja_formatter_faq_q4(inputs)
});